import React from 'react';
import { Tabs } from 'antd';
import { hasAuth } from '../../../utils/NHCore';
//引用的封装工具组件
import getSize from '../../../utils/getSize';


//各个tab页下的查询统计面板
import Xsbdtj from './xsbdtj';
import Xybdtj from './xybdtj';
import Zybdtj from './zybdtj';
import Bjbdtj from './bjbdtj';
import Sydbdtj from './sydbdtj';

//基础样式
import css from './index.css';


const TabPane = Tabs.TabPane;

/**
 * 报到统计查询面板
 * Author: zengxiangkai@ly-sky.com
 * Created on: 2018-08-16 
 * Version: 1.0
 * Modify log:
 */
class IndexComponent extends React.Component {

    constructor(props) {
        super(props);
    }


    render() {
        return (
            <div className={css.main_right_content} style={{ height: getSize().windowH - 123 }}>
                <Tabs>
                    {hasAuth('zhxg_yxgl_tjcx_bdtjcx:school') && <TabPane tab="全校报到统计" key="1"><Xsbdtj /></TabPane>}
                    <TabPane tab="学院报到统计" key="2"><Xybdtj /></TabPane>
                    <TabPane tab="专业报到统计" key="3"><Zybdtj /></TabPane>
                    <TabPane tab="班级报到统计" key="4"><Bjbdtj /></TabPane>
                    <TabPane tab="生源地报到统计" key="5"><Sydbdtj /></TabPane>
                </Tabs>
            </div>
        )
    }

}

export default IndexComponent;


// WEBPACK FOOTER //
// ./components/tjcx/bdtjcx/index.js